module.exports = __webpack_public_path__ + "static/media/icon_income.e69c0b20.svg";